import $ from 'jquery';
import Immutable from 'immutable';

import { View } from 'backbone';
import htmlTemplate from 'properties/advanced/location.ejs';


class LocationView extends View {

    initialize( opts ) {
        this.options = opts || {};
        this.template = htmlTemplate;
        this.tagName = 'div';
        this.id = opts.el;

        this.events = {
            'change input[type=checkbox]' : 'updateAttributes'
        };

        this.listenTo(this.model, 'change', this.render);
        return this;
    }

    updateAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal  = ev.currentTarget.checked;
        this.model.set( propName, propVal );
    }


    render() {
        this.$el.empty();
        if(this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }

        this.delegateEvents();
        return this;
    }

}

export default LocationView;
